export default __webpack_public_path__ + "static/media/img1.16eddc47.PNG";